module.exports = __webpack_public_path__ + "static/media/eg.4263356b.svg";